/**
 * Reads the `RelayState` query parameter from a URL search string
 * (e.g. `?RelayState=%2Ffoo%3Fa%3D1`).
 *
 * Returns the decoded path, or `null` if the parameter is missing or empty.
 * Symmetric counterpart to {@link append}.
 */
export function read(searchStr: string): string | null {
  const value = new URLSearchParams(searchStr).get('RelayState');

  return value || null;
}
